/* eslint-disable no-unused-vars */
import checkboxChecked from './icons/checkboxChecked.svg';
import checkboxCheckedDisabled from './icons/checkboxCheckedDisabled.svg';
import checkboxEmpty from './icons/checkboxEmpty.svg';
import checkboxError from './icons/checkboxError.svg';
import checkboxFocus from './icons/checkboxFocus.svg';
import country from './icons/country.svg';
import dropdownArrow from './icons/dropdownArrow.svg';
import error from './icons/error.svg';
import logoNico from './icons/logoNico.svg';
import popupClose from './icons/popupClose.svg';
import popupCloseSmall from './icons/popupCloseSmall.svg';
import repeat from './icons/repeat.svg';
import spinner from './icons/spinner.svg';
/* eslint-enable */

export {
  checkboxChecked,
  checkboxCheckedDisabled,
  checkboxEmpty,
  checkboxError,
  checkboxFocus,
  country,
  dropdownArrow,
  error,
  logoNico,
  popupClose,
  popupCloseSmall,
  repeat,
  spinner
};



// WEBPACK FOOTER //
// ./src/components/units/Icon/iconsConfig.js